import { useEffect } from 'react';
import { X } from 'lucide-react';
import { siteContent } from '../lib/siteContent';
import { closeManifestDetailPanel, prefillContentSlot } from '../lib/manifestAvatarBridge';

const MAP_TOPICS = siteContent.filter((item) =>
  [
    'self-labs',
    'milan-cheeks',
    'self-phone',
    'self-os',
    'essence',
    'resonatia',
    'ai-avatars',
    'living-websites',
    'living-website',
    'creator-tools',
    'robotics',
    'bci',
    'partnerships',
    'demo',
    'products',
    'contact',
    'technologies',
    'role-model-ai',
    'aura-resonant-layer',
    'harmony-encoder',
    'investors',
    'incubator',
    'consultation',
    'build',
  ].includes(item.id)
);

/** DOM regions Manifest page actions target (scroll, highlight, set_content, show_panel) */
export default function AvatarSiteAwareLayer() {
  useEffect(() => {
    MAP_TOPICS.forEach((topic) => {
      if (topic.id === 'living-websites') return;
      prefillContentSlot(`${topic.id}-detail`, topic.shortDescription);
    });
  }, []);

  return (
    <>
      {/* Scroll/highlight anchors — in document for scroll_to */}
      <div className="avatar-site-anchors" aria-hidden="true">
        {MAP_TOPICS.map((topic) => {
          if (topic.id === 'living-websites') {
            return (
              <div
                key={topic.id}
                data-avatar-content="living-websites-detail"
                className="avatar-content-slot avatar-content-slot--anchor sr-only"
              >
                {topic.shortDescription}
              </div>
            );
          }

          return (
            <section
              key={topic.id}
              id={topic.id}
              data-avatar-target={topic.id}
              className="avatar-target-anchor"
            >
              <h2>{topic.title}</h2>
              <div
                data-avatar-content={`${topic.id}-detail`}
                className="avatar-content-slot avatar-content-slot--anchor"
              >
                {topic.shortDescription}
              </div>
            </section>
          );
        })}
      </div>

      {/* Detail panel Manifest opens with show_panel / set_content */}
      <aside
        id="detail-panel"
        data-avatar-panel="detail-panel"
        className="avatar-detail-panel avatar-panel-hidden"
        hidden
        aria-label="Avatar content panel"
      >
        <header className="avatar-detail-panel__header">
          <p className="avatar-detail-panel__eyebrow">SELF Labs</p>
          <h2 className="avatar-detail-panel__title">Live page content</h2>
          <button
            type="button"
            className="avatar-detail-panel__close"
            onClick={closeManifestDetailPanel}
            aria-label="Close panel"
          >
            <X className="w-4 h-4" />
          </button>
        </header>
        <div
          data-avatar-content="panel-body"
          className="avatar-content-slot avatar-content-slot--panel"
        />
      </aside>
    </>
  );
}
